import { scopes, PermissionExpression } from 'SRC/hooks/useIdentity';

export const page: PermissionExpression = scopes.METRICS_READ;
